import React from 'react'
import { Helmet } from 'react-helmet'

import '../../css/Blog.css'

import EHDO from '../../assets/img/ehdo.jpg'

export default function SeneSchoolProgram() {
  return (
    <div id="article">
      <Helmet>
        <title>EHDO Partook in the Sene 30 School Program - Enoho Fikir</title>
      </Helmet>

      <h1>EHDO Participated in the Sene 30 School Program</h1>
      <img src={ EHDO } />
      <p>EHDO gave rewards to high academic achiever students and best performer teachers at Adwa Ber Shool. Students that ranked from 1st to 3rd were presented with rewards for their hard work and accomplishment. This is believed to be a motivating factor towards achieving a better result. Furthermore, teachers that have demonstrated an outstanding performance were presented with a reward for their exemplary accomplishment in promoting a viable teaching/learning environment. EHDO founding members expressed their commitment towards the realization of a successful teaching/learning process and assured their continued support to the school community to enhance quality education.</p>
    </div>
  )
}